// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { NavLink } from "react-router";
import { About } from "../About";
import { Home } from "../Home";
import { Portafolio } from "../Portafolio";
import { Contact } from "../Contact";
import { Curriculum } from "../Curriculum";

export const Aside = () => {
  return (
    <aside className="layout__aside">
      <section className="aside__user-info">
        {/* Informacion general del usuario */}
        <div className="user-info__general">
          <div className="user-info__container-image">
            <img
              src="assets/img/Gerlin_Gonzalez.png"
              alt="Gerlin Gonzalez"
              className="user-info__image"
            />
          </div>
          <h2 className="user-info__name">Gerlin Gonzalez</h2>
          <h4 className="user-info__job">Analista SOC | Especialista en Seguridad Ofensiva y SIEM</h4>
        </div>

        {/*  Menu de Navegacion */}
        <nav className="layout__menu">
          <ul className="menu__list">
            <li className="menu__option">
              <NavLink to="/inicio" element={<Home />} className="menu__link">
                <i className="menu__icon fa-solid fa-house"></i>
                <span className="menu__overlay ">home</span>
              </NavLink>
            </li>
            <li className="menu__option">
              <NavLink
                to="/sobre-mi"
                element={<About />}
                className="menu__link "
              >
                <i className="menu__icon fa-solid fa-user"></i>
                <span className="menu__overlay ">Sobre mi</span>
              </NavLink>
            </li>
            <li className="menu__option">
              <NavLink
                to="/curriculum"
                element={<Curriculum />}
                className="menu__link "
              >
                <i className="menu__icon fa-solid fa-graduation-cap"></i>
                <span className="menu__overlay ">Curriculum</span>
              </NavLink>
            </li>
            <li className="menu__option">
              <NavLink
                to="/portafolio"
                element={<Portafolio />}
                className="menu__link "
              >
                <i className="menu__icon fa-solid fa-briefcase"></i>
                <span className="menu__overlay ">Portafolio</span>
              </NavLink>
            </li>
            {/* <li className="menu__option">
              <NavLink to="/blog" className="menu__link  ">
                <i className="menu__icon fa-solid fa-book"></i>
                <span className="menu__overlay ">Blog</span>
              </NavLink>
            </li> */}
            <li className="menu__option">
              <NavLink
                to="/contactos"
                element={<Contact />}
                className="menu__link  "
              >
                <i className="menu__icon fa-solid fa-envelope"></i>
                <span className="menu__overlay ">Contacto</span>
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* link redes sociales  */}
        <div className="user-info__links">
          <ul className="links__social">
            
            <li className="social__options">
              <NavLink
                to="www.linkedin.com/in/sadonfa"
                className="social__link"
                target="_blank"
              >
                <i className="social__icon fa-brands fa-linkedin"></i>
              </NavLink>
            </li>
            <li className="social__options">
              <NavLink
                to="https://github.com/sadonfa"
                className="social__link"
                target="_blank"
              >
                <i className="fa-brands fa-github"></i>
                {/* <i className="social__icon fa-brands fa-instagram"></i> */}
              </NavLink>
            </li>
          </ul>
        </div>
        {/* boton de curriculum */}
        <div className="user-info__button">
          <NavLink to="#" className="user-info__btn">
            Descarga CV
          </NavLink>
        </div>

        {/* Pie de pagina  */}
        <footer className="user-info__footer">
          &copy; 2026 Gerlin Gonzalez
        </footer>
      </section>
    </aside>
  );
};
